import React, {useEffect} from 'react';
import {InitData, Poi} from '../react-app-env';
import initData from '../initdata.json';
import {Events, EventType} from '../events/Events';

export function useModel(onModelAvailable?: (model: InitData) => void) {
  const [model, setModel] = React.useState<InitData>();

  // Initialise component

  useEffect(() => {
    const model = initData as any as InitData;
    setModel(model);
    onModelAvailable?.(model);

    const eventSubscriptions = Events.collect();
    eventSubscriptions.subscribe(EventType.ON_POI_UPDATED, (updatedPoi: Poi) => onPoiUpdated(updatedPoi));

    return () => eventSubscriptions.cancel();
  }, []);

  // Private implementation

  function onPoiUpdated(updatedPoi: Poi) {
    setModel(prev => {
      return prev && {
        ...prev,
        trip: {
          ...prev.trip,
          pois: prev.trip.pois.map(poi => poi.id === updatedPoi.id ? updatedPoi : poi)
        }
      }
    });
  }

  // Rendering

  return model;
}
